import { createAction, props } from '@ngrx/store';

export const canActivate = createAction(
  '[Company Exists Guard] Can Activate',
  props<{ companyId: string }>()
);
